export default __webpack_public_path__ + "static/media/srm.5afb2c35.svg";